import { PAUSE_CAMPAIGN, PAUSE_CAMPAIGN_SUCCESS, PAUSE_CAMPAIGN_ERROR, PAUSE_CAMPAIGN_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PauseCampaign = (state = initialState, action) => {
  switch (action.type) {
    case PAUSE_CAMPAIGN:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PAUSE_CAMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PAUSE_CAMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PAUSE_CAMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PauseCampaign;
